import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaProductCategory = yup.object().shape({
  description: yup
    .string()
    .required(
      translate('productCategoriesModal.validation.descriptionRequired'),
    ),
});
